// @flow

const updateByCheckbox = (updateFunc: (key: string, checked: boolean) => void) => (e: SyntheticEvent<HTMLInputElement>) => {
  const { value, checked } = e.currentTarget;
  updateFunc(value, checked);
};

export default updateByCheckbox;
